import { render, staticRenderFns } from "./MessagesToCustomersModal.vue?vue&type=template&id=7a21a122&"
import script from "./MessagesToCustomersModal.vue?vue&type=script&lang=ts&"
export * from "./MessagesToCustomersModal.vue?vue&type=script&lang=ts&"
import style0 from "./MessagesToCustomersModal.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports